



























import { Component, Prop, Mixins, Watch } from 'vue-property-decorator'
import BaseVue from '@/mixins/BaseVue'
import serviceModule from '@/store/modules/ServiceModule'
import { UserInformations } from '@/services/connecteur'

@Component({
  components: {}
})
export default class DPSelect extends Mixins(BaseVue) {
  @Prop({
    default: () => {
      return []
    }
  })
  public idList!: number[]

  @Prop({ default: 0, required: true })
  public salesOrgId!: number

  @Prop({ default: false })
  public disabled!: boolean

  public DPList: UserInformations[] = new Array<UserInformations>()

  public get dpError (): string {
    if (this.idList && this.idList.length) {
      const dps = this.DPList.filter(x =>
        this.idList?.includes(x.id as number)
      )

      if (!dps.length) {
        this.updateError(true)
        return this.$t('promotion.demandPlannerNotValid').toString()
      } else if (dps[0] && dps[0].desactivated) {
        this.updateError(true)
        return this.$t('promotion.demandPlannerNotActivated').toString()
      }
    }

    this.updateError(false)
    return ''
  }

  public updateError (newValue: boolean) {
    this.$emit('update:error', newValue)
  }

  public updateIds (newValue: number[]) {
      this.$emit('update:idList', newValue)
    }

    @Watch('salesOrgId', { immediate: true })
    public async fetchDemandPlanner () {
      try {
        if (this.salesOrgId) {
          this.DPList = await serviceModule.userApi.getAllDemandPlanners(
            this.salesOrgId
          )
        }
      } catch (error) {
        this.displayError(error)
      }
    }
  }
